import React, { useEffect, useState} from "react";
import T from "../t/T";
import "./ModalConfirmation.scss";
import Modal from "react-bootstrap/Modal";
import {connect} from "react-redux";


function ModalConfirmation(props) {
    const [device] = useState(props.device)
    const [language] = useState(props.language)

    const [show, setShow] = useState(props.show)
    const [item, setItem] = useState(null)

    useEffect(()=>{
    }, [])

    useEffect(() => {
        setShow(props.show)
    }, [props.show]);

    useEffect(() => {
        setItem(props?.item)
    }, [props?.item]);


    const closeConfirmation = () => {
        props?.onClose()
    }

    const confirmationYes = () => {
		try{
			props?.onConfirm(item).then(()=>{
	            closeConfirmation()
	        })
		} catch (e) {
			props?.onConfirm(item)
            closeConfirmation()
		}
    }

    const confirmationNo = () => {
        closeConfirmation()
    }


    return ( <>
            {show && <Modal dialogClassName={`${props?.className}__modal`}
                                          show={show}
                                          backdropClassName={`${props?.className}__backdrop`}
                                          centered={true}
                                          onHide={closeConfirmation}
                                          style={{zIndex: 1301}}
            >

                <div className={'imodal'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={closeConfirmation}>
                            <i className={'fa fa-light fa-times-circle'}/>
                        </div>
                        <div className={'imodal__title'}>
                            {props?.title}
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={confirmationYes}
                        >
                            <T token={props.confirmText ?? 'ok'}/>
                        </div>

                        <div className={'imodal__btn imodal__btn--secondary'}
                             onClick={confirmationNo}
                        >
                            <T token={'cancel'}/>
                        </div>
                    </div>
                </div>
            </Modal>}
            </>
    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const device = state.DeviceModeReducer.mode;
    return {language, device};
};

export default connect(mapStateToProps)(ModalConfirmation);